import * as React from "react";
import Routes from "routing/Routes";
import { Button } from "components/bootstrap";
import { LinkContainer, ReadOnlyFormGroup, Spinner } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import useRoles from "common/hooks/useRoles";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import getDisplayName from "authentication/helpers/getDisplayName";
import convertToSeconds from "authentication/helpers/convertToSeconds";
const ConfigSection = ({ authenticationBackend }) => {
  const { id, title, description, defaultRoles, defaultUserTimezone, config } = authenticationBackend;
  const { callbackUrl, clientId, clientSecret, tokenVerifierConnectTimeout, type } = config;
  const isOkta = type === OKTA_TYPE_KEY;
  const baseUrl = isOkta ? config.oktaBaseUrl : config.baseUrl;
  const baseUrlLabel = getDisplayName(type);
  const { isLoading, roles } = useRoles();
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: "Server Configuration",
      headerActions: /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.SYSTEM.AUTHENTICATION.BACKENDS.edit(id, "server_config") }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small" }, "Edit"))
    },
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Title", value: title }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Description", value: description }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: `${baseUrlLabel} base URL`, value: baseUrl }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Callback URL", value: callbackUrl }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Client ID", value: clientId }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Client Secret", value: (clientSecret == null ? void 0 : clientSecret.is_set) ? "******" : null }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Token verifier connect timeout", value: convertToSeconds(tokenVerifierConnectTimeout) }),
    /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: "Default roles",
        value: defaultRoles.map((roleId) => {
          var _a;
          return (_a = roles.find((role) => role.id === roleId)) == null ? void 0 : _a.name;
        }).join(", ")
      }
    ),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "Default user time zone", value: defaultUserTimezone || "Browser's time zone" })
  );
};
export default ConfigSection;
